export default "__VITE_ASSET__wI7EmC3T__"